import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import ManualUploadsBody from './ManualUploadsBody'
import { ModalBody, ModalHeader, Modal } from 'reactstrap'
import { getDeviceInfo } from '../../redux/slices'
import './ManualUploads.css'
import { DefaultState } from '../../types'

const ManualUploads = () => {
  const {deviceId} = useParams()
  const manualUploads = useSelector(
    (state: DefaultState) => state.manualUploads.data
  )
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getDeviceInfo(deviceId))
  }, [])

  return (
    <div
      id='manual_uploads_background'
      className='fade show'
      role='dialog'
      tabIndex={-1}
    >
      <Modal
        id='manual_uploads_modal'
        isOpen={true}
      >
        <ModalHeader className={'ics-modal-header'} id='manual_uploads_header'>
            Manual Uploads
        </ModalHeader>
        <span style={{marginTop:'10px',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
        <b><h6 style={{fontSize:'18px',fontWeight:600}}>{manualUploads.name}</h6></b>
        <p style={{marginBottom:'0px',fontSize:'18px',color:'#495057'}}>{manualUploads.deviceType} {manualUploads.serial}</p>
        </span>
          <ModalBody id='manual_uploads_body'>
            <ManualUploadsBody />
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ManualUploads